module.exports = __webpack_public_path__ + "static/media/solution(1).d230236a.svg";